import { dateAndTimeConverter } from "./Constants";

export const proceduresTableHeadings = [
  {
    title: "SI.No",
    width: "70px",
    textAlign: "left"
  },
  {
    title: "TITLE",
    width: "300px",
    textAlign: "left"
  },
  {
    title: "TYPE",
    width: "70px",
    textAlign: "right"
  }
];

export const procedureTableField = (data) => {
  switch (data) {
    case "SI.No":
      return "serialNo";
    case "TITLE":
      return "title";
    case "TYPE":
      return "procedureType";
    default:
      return data?.toLowerCase();
  }
};

export const proceduresFilterData = () => [
  {
    key: "type",
    title: "TYPE",
    multiple: true,
    options: ["Employee", "Sensor", "Logistics"]
  }
];

export const defaultProcedureFilter = {
  type: [],
  dateRange: { from: null, to: null, type: "Lifetime" }
};

export const defaultProcedureStep = {
  title: "",
  description: "",
  isProofRequired: false
};

export function convertToTableData(data) {
  const tableData = [];

  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    const transformedItem = {
      ...item,
      serialNo: i + 1,
      documentId: item?.documentId,
      title: item?.title,
      type: item?.procedureType,
      createdAt: `${dateAndTimeConverter(
        item?.createdAt,
        "Time"
      )}, ${dateAndTimeConverter(item?.createdAt, "thirdDate")}`
    };
    tableData.push(transformedItem);
  }
  return tableData;
}

export const hours = {
  "12:00 AM": "00:00",
  "01:00 AM": "01:00",
  "02:00 AM": "02:00",
  "03:00 AM": "03:00",
  "04:00 AM": "04:00",
  "05:00 AM": "05:00",
  "06:00 AM": "06:00",
  "07:00 AM": "07:00",
  "08:00 AM": "08:00",
  "09:00 AM": "09:00",
  "10:00 AM": "10:00",
  "11:00 AM": "11:00",
  "12:00 PM": "12:00",
  "01:00 PM": "13:00",
  "02:00 PM": "14:00",
  "03:00 PM": "15:00",
  "04:00 PM": "16:00",
  "05:00 PM": "17:00",
  "06:00 PM": "18:00",
  "07:00 PM": "19:00",
  "08:00 PM": "20:00",
  "09:00 PM": "21:00",
  "10:00 PM": "22:00",
  "11:00 PM": "23:00"
};
